import useCookieConsent from "../hooks/useCookieConsent";
import ChatbotWidget from "./ChatbotWidget";
import WhatsAppWidget from "./WhatsAppWidget";

/**
 * Single fixed-position anchor for every bottom-right engagement widget
 * (ZP-88's WhatsApp FAB, ZP-89's chatbot launcher) — centralizes the
 * cookie-banner-avoidance offset in one place instead of duplicating it
 * per widget, and guarantees the two can never visually overlap since
 * they're laid out in the same flex stack rather than independently
 * positioned. WhatsApp renders last so it sits closest to the screen edge
 * (the more familiar, lower-commitment action); the chatbot panel expands
 * upward from its own launcher without disturbing WhatsApp's position.
 */
export default function EngagementWidgetStack() {
  const { preferences } = useCookieConsent();

  return (
    <div
      className={`fixed right-5 z-40 flex flex-col items-end gap-3 transition-[bottom] duration-300 ${
        preferences === null ? "bottom-28 sm:bottom-24" : "bottom-6"
      }`}
    >
      <ChatbotWidget />
      <WhatsAppWidget />
    </div>
  );
}
